<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Sincere thanks to the staff of the Tampa Theatre, especially Jill Witecki, John Bell and former staff member Tara Schroeder; to all the many students and former students of the University of Tampa who have shared their stories with me over the years; to the Tampa History Center Research Library, especially David and Phyllis; to Paul Guzzo, for his information and inspiration regarding Charlie Wall; to Michelle, Derek, Jensen and Forest of Duckweed Urban Market; to the staff of the Hotel Floridan, especially April, Daniel, Costa and, of course, Tony at the piano; to Lynn Brown, for believing in me; to Donna and Steve Bremer, who first helped me to become a writer; to Tim Reeser, for allowing me to tell ghost stories on the streets of Tampa; and most of all to Craig, for photographic and technical support, holding my hand or kicking my rear as needed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?23b16207